import { Link } from 'react-router-dom';
import { useState } from 'react';
import ContactFormModal from './ContactFormModal';
import KitFormModal from './KitFormModal';

export default function Footer() {
  const [isContactFormOpen, setIsContactFormOpen] = useState(false);
  const [isKitFormOpen, setIsKitFormOpen] = useState(false);

  return (
    <>
      <footer className="bg-[#1A1F2E] text-[#C5C9D1]">
        <div className="container mx-auto px-6 lg:px-20 py-16">
          <div className="grid md:grid-cols-4 gap-12">
            {/* Column 1 - Brand */}
            <div className="space-y-4">
              <div className="flex items-center gap-3">
                <img 
                  src="https://public.readdy.ai/ai/img_res/b2886c74-45c3-4d22-86ef-90787632f795.png" 
                  alt="FallbackFunds Logo" 
                  className="h-10 w-auto"
                />
              </div>
              <p className="text-[#D4AF37] text-sm font-semibold">
                Tactical Financial Defense
              </p>
              <p className="text-sm leading-relaxed">
                Building backup liquidity through strategic 0% credit stacking.
              </p>
            </div>

            {/* Column 2 - Quick Links */}
            <div>
              <h3 className="text-[#F5F5F0] font-bold text-lg mb-4">Quick Links</h3>
              <ul className="space-y-3">
                <li>
                  <Link to="/" className="text-sm hover:text-[#D4AF37] transition-colors cursor-pointer">
                    Home
                  </Link>
                </li>
                <li>
                  <button 
                    onClick={() => setIsKitFormOpen(true)}
                    className="text-sm hover:text-[#D4AF37] transition-colors cursor-pointer text-left"
                  >
                    Pre-Qualify
                  </button>
                </li>
                <li>
                  <Link to="/privacy" className="text-sm hover:text-[#D4AF37] transition-colors cursor-pointer">
                    Privacy Policy
                  </Link>
                </li>
                <li>
                  <Link to="/terms" className="text-sm hover:text-[#D4AF37] transition-colors cursor-pointer">
                    Terms of Service
                  </Link>
                </li>
              </ul>
            </div>

            {/* Column 3 - Partnerships */}
            <div>
              <h3 className="text-[#F5F5F0] font-bold text-lg mb-4">Our Partners</h3>
              <div className="space-y-4">
                <div className="border-l-2 border-[#D4AF37] pl-4">
                  <p className="text-sm font-semibold text-[#F5F5F0]">
                    Guiding Light Partners
                  </p>
                  <p className="text-xs text-[#C5C9D1] mt-1">
                    Strategic Financial Guidance
                  </p>
                </div>
                <div className="border-l-2 border-[#D4AF37] pl-4">
                  <p className="text-sm font-semibold text-[#F5F5F0]">
                    Loophole Lending
                  </p>
                  <p className="text-xs text-[#C5C9D1] mt-1">
                    Credit Strategy Specialists
                  </p>
                </div>
              </div>
            </div>

            {/* Column 4 - Contact */}
            <div>
              <h3 className="text-[#F5F5F0] font-bold text-lg mb-4">Contact</h3>
              <div className="space-y-3">
                <div className="flex items-start gap-3">
                  <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-shield-check-line text-[#D4AF37] text-lg"></i>
                  </div>
                  <p className="text-sm">
                    Secure, confidential consultations
                  </p>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-mail-line text-[#D4AF37] text-lg"></i>
                  </div>
                  <button 
                    onClick={() => setIsContactFormOpen(true)}
                    className="text-sm hover:text-[#D4AF37] transition-colors cursor-pointer text-left"
                  >
                    Send us a message
                  </button>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-phone-line text-[#D4AF37] text-lg"></i>
                  </div>
                  <a href="tel:+17024183700" className="text-sm hover:text-[#D4AF37] transition-colors cursor-pointer">
                    (702) 418-3700
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="bg-[#0D1B2A] py-6">
          <div className="container mx-auto px-6 lg:px-20">
            <div className="flex flex-col md:flex-row items-center justify-between gap-4 text-sm">
              <p className="text-[#B8964F]">
                © 2026 FallbackFunds. All rights reserved.
              </p>
              <div className="flex items-center gap-2 text-[#B8964F]">
                <span>Powered by Guiding Light Partners</span>
                <span className="text-[#D4AF37]">|</span>
                <span>In partnership with Loophole Lending</span>
              </div>
            </div>
          </div>
        </div>
      </footer>

      <ContactFormModal 
        isOpen={isContactFormOpen} 
        onClose={() => setIsContactFormOpen(false)} 
      />
      
      <KitFormModal 
        isOpen={isKitFormOpen} 
        onClose={() => setIsKitFormOpen(false)} 
      />
    </>
  );
}